module.exports = __webpack_public_path__ + "img/symbol_6.688c9e2a.png";